import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import logo from 'assets/logo.png'

import BaseLayoutAdjustable from 'components/form/BaseLayoutAdjustable'
import bg from 'assets/bg.png'
import 'assets/stylesheets/application.css';
import AccountInfoUser from 'components/AccountInfoUser'
import yellowBgLong from 'assets/BaseImg/yellowBgLong.png'
import darkBgLong from 'assets/BaseImg/darkBgLong.png'
import information from 'assets/information.png'

import courseActions from 'actions/course';
import courseTypeActions from 'actions/coursetype'

const useStyles = makeStyles(() => ({
  container1: {
    width: "70vw",
    height: "70vh",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "column",
  },
  row1: {
    display: 'flex',
    width: '100%',
    '& img' : {
      width:'100%',
    }
  },
  overview: {
        width:'250%',
        marginTop:'10px',
        minWidth:'150px',
        maxWidth:'170px',
        margin:'0 auto',
        cursor:'pointer',
        '& img' : {
            width:'250%',
        }
    },
  overviewHidden: {
    width: '250%',
    marginTop: '10px',
    minWidth: '150px',
    maxWidth: '170px',
    margin: '0 auto',
    opacity: 0,
    '& img': {
      width: '250%',
    }
  },
    headerBar : {
        padding:'40px 0px',
        display: 'flex',
        float:'right',
        color:'white',
        marginright:'20px',
        justifyContent: 'center',
        '& img': {
            height: '50%'
        },
        '& h4': {
            paddingRight: '6px',
            paddingTop: '9px',
            float:'right',
            fontFamily: 'impact',
        },
        '& h5': {
            fontFamily: 'impact'
        }
    },
  mainContainer: {
    display: 'flex',
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  topInfo: {
    width: "100vw",
    display: "flex",
    alignItems: "center",
    paddingLeft: "6rem",
    paddingRight: "6rem",
    justifyContent: "space-between",
  },
  logo: {
    width: '12rem'
  },
  containerOverViewData: {
    padding: "40px",
    marginLeft: '5rem',
    marginRight: '2rem',
    color: "white",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    "& h4": {
      fontFamily: "Impact",
      margin: "10px",
    },
    '& h5':{
        fontFamily: "Impact",
        letterSpacing: "1px",
        marginBottom: '0rem'
      },
      '& row': {
        fontFamily: "Impact",
      }
  },
  hidden: {
    opacity: 0
  },
  inputWrapper: {
    position: 'relative',
    width: "50%",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '& p': {
      color: '#FFFFFF',
      position: 'fixed',
      fontSize: '1.6vw',
      fontFamily: 'impact',
      letterSpacing: '1px',
      textAlign: 'center',
      lineHeight: '1.4em',
    }
  },
  inputWrapper1: {
    position: 'relative',
    width: "50%",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '& p': {
      color: '#FFFFFF',
      fontFamily: 'impact',
      letterSpacing: '1px',
      position: 'fixed',
      fontSize: '2rem',
      width: "21.5rem"
    }
  },
  inputWrapperHidden: {
    position: 'relative',
    width: "50%",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    paddingBottom: '2rem',
    opacity: 0,
    '& p': {
      color: '#FFFFFF',
      fontFamily: 'impact',
      letterSpacing: '1px',
      position: 'fixed',
      fontSize: '2rem',
    }
  },
  temporary : {
    display: 'flex',
    flexDirection: 'column',
    width: "100vw",
    height: "85vh",
    justifyContent: "center",
  },
  information: {
    left: '5vw',
    width: '40px',
    bottom: '10vh',
    height: '40px',
    position: 'absolute',
    cursor: 'pointer',

    '& img': {
      width: '100%',
    }
  },
}));

const CorporateUserOverView = () => {
  const dispatch = useDispatch()
  const classes  = useStyles();
  const name = useSelector((state: any) => state.auth.loggedinuser.user.name)
  const id = useSelector((state: any) => state.auth.loggedinuser.user.id)
  const hasCourseTypes = useSelector((state: any) => state.corporateReducer.hasCourseTypes)
  const hasCourses = useSelector((state: any) => state.corporateReducer.hasCourses)
  const numberofsession = useSelector((state: any) => state.auth.numberofsession)
  const accessToken = useSelector((state: any) => state.auth.loggedinuser.token.accessToken)
  const [corporateLogo, setCorporateLogo] = useState('NIL')
  const [companyname, setcompanyname] = useState('NIL')

  const getCoporateInfo = async () => {
    const DataOfUser = await axios({
      method: 'get',
      url: 'https://museum.createscape.com.sg/exhibitorinfo/' + id,
      headers: {
        "content-type": "application/json",
        "Authorization": "Bearer "+accessToken
      },
    })
    let datacollected = DataOfUser.data.data[0]
    setcompanyname(datacollected.companyname)
    setCorporateLogo(datacollected.logo)
    return DataOfUser;
  }

  const [isItStartOfPage, setisItStartOfPage] = useState(true)

  useEffect(() => {
    getCoporateInfo()
    if (isItStartOfPage === true) {
      setisItStartOfPage(false)
    }
    dispatch(courseTypeActions.getcoursetypebyuserid.started({userid: id}))
    dispatch(courseActions.getcoursesbyuserid.started({userid: id}))
  }, []);

  return (
    <div>
      <BaseLayoutAdjustable bg={bg}>
        <div className={classes.mainContainer}>
          <div className={classes.topInfo}>
            <img src={logo} alt="logo" className={classes.logo} />
            <div className={classes.containerOverViewData}>
              <h5>{companyname}</h5>
              <h4> | </h4>
              <h4>CORPORATE ACCOUNT</h4>
              <h4> | </h4>
              <h4>Remaining Session: {numberofsession}</h4>
              <h4> | </h4>
            </div>
            <AccountInfoUser name={name} />
          </div>
          <div className={classes.container1}>
            <div className={classes.row1}>
              <div className={classes.inputWrapper} onClick={() => dispatch (push('/corporate/profilesetup', corporateLogo))}>
                <img src={yellowBgLong} alt="bg" />
                <p>CORPORATE PROFILE SETUP</p>
              </div>
              <div className={classes.inputWrapper}>
                <img src={darkBgLong} alt="bg" />
                <p>COURSE MANAGER MANAGEMENT</p>
              </div>
            </div>
            <div className={classes.row1}>
              <div className={classes.inputWrapper} onClick={() => dispatch(push('/corporate/coursetypelisting'))}>
                <img src={yellowBgLong} alt="bg" />
                <p>COURSE TYPE MANAGEMENT</p>
              </div>
              {hasCourseTypes == 0 ?
                <div className={classes.inputWrapper}>
                  <img src={darkBgLong} alt="bg" />
                  <p>COURSE MANAGEMENT</p>
                </div>
                :
                <div className={classes.inputWrapper} onClick={() => dispatch(push('/corporate/courselisting'))}>
                  <img src={yellowBgLong} alt="bg" />
                  <p>COURSE MANAGEMENT</p>
                </div>
              }
            </div>
            <div className={classes.row1}>
              {(hasCourseTypes == 0 || hasCourses == 0) ?
                <div className={classes.inputWrapper}>
                  <img src={darkBgLong} alt="bg" />
                  <p>TRAINEE MANAGEMENT</p>
                </div>
                :
                <div className={classes.inputWrapper} onClick={() => dispatch(push('/corporate/traineelisting'))}>
                  <img src={yellowBgLong} alt="bg" />
                  <p>TRAINEE MANAGEMENT</p>
                </div>
              }
              <div className={classes.inputWrapper} onClick={() => dispatch(push('/corporate/performancerecords'))}>
                <img src={yellowBgLong} alt="bg" />
                <p>PAST TRAINING SESSIONS<br />PERFORMANCE RECORD</p>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.information} onClick={() => window.open('https://www.createscape.com.sg/documents/corporate-account-user-manual.pdf')} >
          <img src={information}/>
        </div>
      </BaseLayoutAdjustable>
    </div>
  )
}

export default CorporateUserOverView;